<template>
  <q-tabs active-color="primary-pure">
    <q-tab
      v-for="tab in tabs"
      :key="tab.name"
      :ripple="false"
      :name="tab.name"
      class="relative flex-nowrap px-24 max-w-max"
      :disable="tab?.disable"
    >
      <div class="flex items-center gap-8">
        <q-icon v-if="tab.icon" :name="tab.icon" />
        <p class="text-neutral-100 text-pararaphy-1">{{ tab.label }}</p>
      </div>
    </q-tab>
  </q-tabs>
</template>

<script setup>
const props = defineProps({
  tabs: Array,
})
</script>

<style lang="sass">
.OTabs .q-tab--active .q-tab__label
  font-weight: 500 !important
</style>
